import { FunctionComponent } from "react";
import classNames from "classnames";
import "./PageTitle.scss";

type PageTitleProps = {
    classNames?: string;
    icon: string;
    iconColor: "success" | "error" | "default";
    title: string;
};

export const PageTitle: FunctionComponent<PageTitleProps> = (props) => {
    return (
        <div className={classNames("page-title", props.classNames)}>
            <i className={classNames("icon", "color-" + props.iconColor, props.icon)} />

            <h2 className="title">{props.title}</h2>

            {props.children}
        </div>
    );
};
